import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegistrationRoutingApiService {

  constructor(private http: HttpClient) {
  }

  readonly registrationUrl: string = 'configuration/registration';


  public getRegistrationRoutingSettings(): Observable<any> {
    return this.http.get(this.registrationUrl);
  }

  public editRegistrationRoutingSettings(registrationRoutingSettings): Observable<any> {
    return this.http.put(this.registrationUrl, registrationRoutingSettings);
  }
}
